import type { SkillId, SkillProgress } from "@idle-rpg/shared";
import { levelForXp } from "@idle-rpg/shared";

type SkillProgressDelta = {
  skillId: SkillId;
  xp: number;
  levelUp?: { newLevel: number } | null;
};

export function applySkillProgressDelta(
  skills: SkillProgress[] | null | undefined,
  payload: SkillProgressDelta
): SkillProgress[] {
  if (!skills || skills.length === 0) return skills ?? [];
  const index = skills.findIndex((entry) => entry.id === payload.skillId);
  if (index === -1) return skills;

  const entry = skills[index];
  const delta = Math.max(0, Math.floor(Number(payload.xp) || 0));
  const nextXp = Math.max(0, Math.floor(Number(entry.xp) + delta));
  const computedLevel = levelForXp(nextXp);
  const forcedLevel = payload.levelUp?.newLevel;
  const nextLevel =
    typeof forcedLevel === "number" && Number.isFinite(forcedLevel)
      ? Math.max(computedLevel, forcedLevel)
      : computedLevel;

  if (nextXp === entry.xp && nextLevel === entry.level) return skills;

  const updated = { ...entry, xp: nextXp, level: Math.max(entry.level, nextLevel) };
  const nextSkills = [...skills];
  nextSkills[index] = updated;
  return nextSkills;
}
